import * as yup from 'yup';

import { GenderOptions } from '../types/program';
import { AllowedFileTypes } from '../types/programModulesAndContents';
import { baseImageFieldSchema } from './imageSchema';

const REQUIRED_MESSAGE = 'Por favor, preencha este campo';

export const contentStepSchema = yup.object({
  modules: yup.array().of(
    yup.object({
      moduleId: yup.number().required(REQUIRED_MESSAGE),
      title: yup.string().required(REQUIRED_MESSAGE),
      description: yup.string().nullable(),
      order: yup.number().nullable(),
      contents: yup.array().of(
        yup.object({
          contentId: yup.number().required(REQUIRED_MESSAGE),
          title: yup.string().required(REQUIRED_MESSAGE),
          order: yup.number().required(REQUIRED_MESSAGE),
          type: yup
            .string()
            .oneOf(Object.values(AllowedFileTypes))
            .required(REQUIRED_MESSAGE),
          directory: yup.string().when('type', ([type], schema) => {
            return type === AllowedFileTypes.Video
              ? schema.concat(yup.string().required(REQUIRED_MESSAGE))
              : schema.concat(yup.string().nullable());
          }),
          instructorId: yup.number().nullable(),
          neutralThumb: baseImageFieldSchema.when(
            '$gender',
            ([gender]: Array<GenderOptions[]>, schema) => {
              return gender?.includes(GenderOptions.Neutral)
                ? schema.concat(
                    yup.object({
                      preview: yup
                        .string()
                        .required('Imagem neutra obrigatória'),
                    })
                  )
                : schema.concat(
                    yup.object({
                      preview: yup.string().nullable(),
                    })
                  );
            }
          ),
          femaleThumb: baseImageFieldSchema.when(
            '$gender',
            ([gender]: Array<GenderOptions[]>, schema) => {
              return gender?.includes(GenderOptions.Female)
                ? schema.concat(
                    yup.object({
                      preview: yup
                        .string()
                        .required('Imagem feminina obrigatória'),
                    })
                  )
                : schema.concat(
                    yup.object({
                      preview: yup.string().nullable(),
                    })
                  );
            }
          ),
          maleThumb: baseImageFieldSchema.when(
            '$gender',
            ([gender]: Array<GenderOptions[]>, schema) => {
              return gender?.includes(GenderOptions.Male)
                ? schema.concat(
                    yup.object({
                      preview: yup
                        .string()
                        .required('Imagem masculina obrigatória'),
                    })
                  )
                : schema.concat(
                    yup.object({
                      preview: yup.string().nullable(),
                    })
                  );
            }
          ),
          tags: yup.array().of(yup.string()),
          description: yup.string().nullable(),
          file: yup.object({
            fileUrl: yup.string().required(REQUIRED_MESSAGE),
            fileName: yup.string().nullable(),
          }),
        })
      ),
    })
  ),
});

export type ContentStepForm = yup.InferType<typeof contentStepSchema>;
